// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-Avatar {
  object-fit: cover;
  overflow: hidden;
  display: inline-block;
}
.n-Avatar--size-xxs {
  width: 16px;
  height: 16px;
}
.n-Avatar--size-xs {
  width: 20px;
  height: 20px;
}
.n-Avatar--size-sm {
  width: 24px;
  height: 24px;
}
.n-Avatar--size-md {
  width: 32px;
  height: 32px;
}
.n-Avatar--size-lg {
  width: 40px;
  height: 40px;
}
.n-Avatar--size-xl {
  width: 125px;
  height: 125px;
}
.n-Avatar--shape-round {
  border-radius: 50%;
}
.n-Avatar--shape-round-rect {
  border-radius: 20%;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/avatar/Avatar.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AANA;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;AAQF;AALI;EACE,WAAA;EACA,YAAA;AAON;AAJI;EACE,WAAA;EACA,YAAA;AAMN;AAHI;EACE,WAAA;EACA,YAAA;AAKN;AAFI;EACE,WAAA;EACA,YAAA;AAIN;AADI;EACE,WAAA;EACA,YAAA;AAGN;AAAI;EACE,YAAA;EACA,aAAA;AAEN;AAGI;EACE,kBAAA;AADN;AAII;EACE,kBAAA;AAFN","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n\n.n-Avatar {\n  object-fit: cover;\n  overflow: hidden;\n  display: inline-block;\n\n  &--size {\n    &-xxs {\n      width: @Avatar-size-xxs;\n      height: @Avatar-size-xxs;\n    }\n\n    &-xs {\n      width: @Avatar-size-xs;\n      height: @Avatar-size-xs;\n    }\n\n    &-sm {\n      width: @Avatar-size-sm;\n      height: @Avatar-size-sm;\n    }\n\n    &-md {\n      width: @Avatar-size-md;\n      height: @Avatar-size-md;\n    }\n\n    &-lg {\n      width: @Avatar-size-lg;\n      height: @Avatar-size-lg;\n    }\n\n    &-xl {\n      width: @Avatar-size-xl;\n      height: @Avatar-size-xl;\n    }\n  }\n\n  &--shape {\n    &-round {\n      border-radius: 50%;\n    }\n\n    &-round-rect {\n      border-radius: 20%;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
